import { useSingletonAsync, singletonCache } from "./useSingletonAsync";
import { API_BASE } from "../config";

export interface OptionItem {
    label: string;
    value: any;
}

export interface OverlayInput {
    depends_on: any;
    key: string;
    label: string;
    control: string;
    value_type?: string;
    options?: OptionItem[];
    options_source?: string;
    default?: any;
    tooltip?: string;
}

export interface OverlayType {
    id: string;
    label: string;
    properties: OverlayInput[];
}

export function useOverlayTypes() {
    const { data } = useSingletonAsync<OverlayType[]>(
        "overlay_types",
        async () => {
            const res = await fetch(`${API_BASE}/overlay/types`);
            if (!res.ok) throw new Error(`GET /overlay/types → HTTP ${res.status}`);
            const json = await res.json();
            return json;
        }
    );
    return data ?? [];
}

export async function preloadOverlayTypes() {
    if (!singletonCache["overlay_types"]) {
        const res = await fetch(`${API_BASE}/overlay/types`);
        if (!res.ok) throw new Error(`GET /overlay/types → HTTP ${res.status}`);
        const data = await res.json();
        singletonCache["overlay_types"] = {
            promise: Promise.resolve(data),
            data,
            error: null,
        };
    }
}
